import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  saveLoader: false,
  specializationLength: 0,
  specialization: [],
  specializationError: "",
  formError: "",
}

export default function specializationReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_SPECIALIZATION:
      return {...state, loading: action.payload}
    case actions.SAVE_LOADER_SPECIALIZATION:
      return {...state, saveLoader: action.payload}
    case actions.GET_SPECIALIZATION:
      return {...state, specialization: action.payload.specialization, specializationLength: action.payload.specializationLength}
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.SPECIALIZATION_FAIL:
      return { ...state, specializationError: action.payload };
    default:
      return state;
  }
}